<template>
  <!-- eslint-disable vue/attribute-hyphenation -->
  <OptionalValidationWrapper
    :errorStyleExceptions="errorStyleExceptions"
    :handleError="handleError"
    :label="label"
    :name="name"
    :tooltip="tooltip"
  >
    <textarea
      :id="id"
      :autocomplete="autocomplete"
      :class="{
        [$style.textarea]: true,
        [$style.resizeableInput] : resizeable,
        [$style.smallInput] : smallInput,
        [$style.onlyBreakAtNewlines] : onlyBreakAtNewlines,
        [invalid]: handleError()
      }"
      :data-lpignore="dataLpignore"
      :data-vv-scope="scope"
      :disabled="disabled"
      :name="name"
      :placeholder="placeholder"
      :readonly="readonly"
      :required="required"
      :rows="rows"
      :spellcheck="spellcheck"
      :value="value"
      @blur="$emit('blur', $event.currentTarget.value)"
      @change="valueChange"
      @focus="$emit('focus')"
      @input="valueChange"
      @keydown.enter="$emit('enter', $event.currentTarget.value)"
    />
  </OptionalValidationWrapper>
</template>
<script>
import OptionalValidationMixin from 'client/components/FormValidation/mixins/OptionalValidationMixin';
import OptionalValidationWrapper from 'client/components/FormValidation/OptionalValidationWrapper.vue';
import TooltipPropMixin from 'components/FormValidation/mixins/TooltipPropMixin';

export default {
  name: 'Textarea',

  components: {
    OptionalValidationWrapper,
  },

  mixins: [
    OptionalValidationMixin,
    TooltipPropMixin,
  ],

  props: {
    onlyBreakAtNewlines: {
      type: Boolean,
      default: false,
    },
    resizeable: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: null,
    },
    smallInput: {
      type: Boolean,
      default: false,
    },
    spellcheck: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style module>
@import "./css/FormValidationFields.css";
</style>
